import { useState } from "react";
import { cn } from "@/utils/classes";

/* Prop Types */
interface RendererImageProps {
  src: string;
  alt: string;
  className?: string;
}

/**
 * RendererImage component
 *
 * An <img> for renderer-backed thumbnails/frames, which can be slow to generate even at small
 * sizes. Keeps a skeleton in its place until the image has actually finished loading, instead of
 * leaving a blank gap between the surrounding skeleton disappearing and the image painting.
 */
export const RendererImage = ({ src, alt, className }: RendererImageProps) => {
  /* State */
  const [isLoaded, setIsLoaded] = useState(false);

  /* Render */
  return (
    <div className={cn("relative overflow-hidden", className)}>
      {!isLoaded && <div className="skeleton absolute inset-0" />}
      <img
        src={src}
        alt={alt}
        onLoad={() => setIsLoaded(true)}
        className={cn("absolute inset-0 size-full object-cover transition-opacity duration-200", isLoaded ? "opacity-100" : "opacity-0")}
      />
    </div>
  );
};
